<template>
  <div class="introduction">
    <!-- <van-pull-refresh @refresh="onRefresh" v-model="refreshing"> -->
    <van-list v-model="loading" :finished="finished" finished-text="" @load="onLoad">
      <div class="introduction-top">
        <div class="introduction-left" v-if="roomSystemInfo && roomSystemInfo.appImage">
          <van-image width="100%" height="100%" fit="cover" :src="roomSystemInfo.appImage" />
        </div>
        <div class="introduction-info">
          <div class="introduction-title" style="margin: 16px 0 3px 0;">
            <div :class="{ roomTitle: true, ellipsis: !isBs }" v-if="room.roomTitle">{{ room.roomTitle }}</div>
            <span v-if="room.liveStartTime">开播时间：{{ room.liveStartTime.substring(0, room.liveStartTime.length - 3) }}</span>
            <span v-if="room.liveEndTime">结束时间：{{ room.liveEndTime.substring(0, room.liveEndTime.length - 3) }}</span>
          </div>
        </div>
      </div>
      <div class="introduction-dark" :class="{ 'right-padding': needRightPadding }" v-if="room.attrs && room.attrs.theme == 'dark'">
        <LongTouch tag="p" style="user-select: none" needCopy @copy="copy">
          <span><p v-html="room.liveDepiction"></p></span>
        </LongTouch>
      </div>
      <div class="introduction-content ql-editor" :class="{ 'right-padding': needRightPadding }" v-else>
        <LongTouch tag="p" style="user-select: none" needCopy @copy="copy">
          <p id="live-depiction" v-html="room.liveDepiction"></p>
        </LongTouch>
      </div>
    </van-list>
    <!-- </van-pull-refresh> -->
  </div>
</template>
<script>
import store from '@/core/config.store';
export default {
  name: 'Introduction',
  data() {
    return {
      count: 0,
      praisestate: '',
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      job: 0,
      room: $$.module.data.room.roomSettingContent.roomInfo,
      roomRefurbish: $$.module.data.room.roomRefurbish,
      roomSystemInfo: $$.module.data.room.roomSystemInfo,
      roomCount: $$.module.data.room.roomCount,
      firenum: 100,
      jobnum: 100,
      fire: 0
      // firenum:''
    };
  },
  computed: {
    needRightPadding() {
      return store.state.suswindowHasBtn;
    },
    isBs() {
      return $$.module.data.room.siteId === '310113';
    }
  },
  mounted() {
    this.roomRefurbish.filter((item) => {
      if (item.refurbishName == 'like') {
        this.praisestate = item.refurbishFlg;
      }
    });
  },
  methods: {
    copy() {
      this.$toast('copy');
      const text = document.getElementById('live-depiction').textContent;
      console.log('复制简介', text);
      rmt?.setClipboardText({
        text: text //要设置的文本
      });
      this.$toast('已复制');
    },
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.refreshing = false;
        }
        this.finished = true;
      }, 1000);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    fireChange() {
      // console.log(fire)
      this.firenum = this.fire + this.firenum;
      // this.jobnum = job + this.jobnum
      // Toast('当前值：' + fire );
    },
    jobChange() {
      // console.log(fire)
      // this.firenum = fire +this.firenum
      this.jobnum = this.job + this.jobnum;
      // Toast('当前值：' + fire );
    }
  }
};
</script>
<style scoped lang="less">
.long-touch-wrap {
  position: relative;
}
.roomTitle {
  height: 100%;
}
</style>
